import {Component, Input} from '@angular/core';
import {DailyFootfallPrediction} from '../../../classes/models/prediction/DailyFootfallPrediction';
import {ChartConfiguration} from 'chart.js';
import moment from 'moment';
import {BarChartOptions} from '../../../util/BarChartOptions';
import {SHARED_IMPORTS} from "../../../shared/standalone-imports";

/**
 * This component displays footfall predictions bar chart totals for a week.
 */
@Component({
  selector: 'app-footfall-week-totals',
  templateUrl: './footfall-week-totals-chart.component.html',
  styleUrls: ['./footfall-week-totals-chart.component.less'],
  imports: [SHARED_IMPORTS]
})
export class FootfallWeekTotalsComponent {
  /** Options of a bar chart. */
  chartOptions: ChartConfiguration['options'];
  /** Labels of a bar chart. */
  chartLabels: ChartConfiguration<'bar'>['data']['labels'] = [];
  /** The data, which is displayed in the chart (colors and footfall predictions). */
  chartData: ChartConfiguration<'bar'>['data']['datasets'] = [];

  private _dailyPredictions: DailyFootfallPrediction[];
  private graphScale = 1.12;

  /**
   * Sets daily footfall predictions and updates a bar chart.
   * @param dailyPredictions daily footfall predictions to be displayed in the bar chart.
   */
  @Input()
  set dailyPredictions(dailyPredictions: DailyFootfallPrediction[]) {
    this._dailyPredictions = dailyPredictions;
    this.updateCharts();
  }

  private updateCharts() {
    this.chartOptions = BarChartOptions.getChartOptions();
    this.chartLabels = this._dailyPredictions.map(
            dailyPrediction => moment(dailyPrediction.date, 'YYYY-MM-DD').format('dddd'));
    this.chartData = [{
      label: '',
      backgroundColor: '#b2007c',
      borderColor: '#b2007c',
      hoverBackgroundColor: '#5c2483',
      hoverBorderColor: '#5c2483',
      borderWidth: 1,
      data: this._dailyPredictions.map(dailyPrediction => dailyPrediction.sumAndRoundUpFootfall())
    }];
    this.chartOptions.scales.y.max = this.findHighestDailyFootfall() * this.graphScale;
  }

  private findHighestDailyFootfall(): number {
    return Math.max.apply(Math, this._dailyPredictions.map(
            dailyPrediction => dailyPrediction.sumAndRoundUpFootfall()));
  }
}
